import { ApolloLink } from '@apollo/client';

import errorLink from './error';
import operation from './operation';
import retryLink from './retry';

const link = ApolloLink.from([retryLink, errorLink, operation]);

export default link;
